module.exports = "/_next/static/images/fc38c456a48acb1cab268ee80932c91f-girl-holding-phone@0.75x.jpg.webp";